import type {CodeList} from 'services/codelists/types';
import type {ManifestationImportProps} from 'services/metadata/types';
import {isMerchProductForm, isNullish} from 'services/utils';
import {CodeListRef} from 'schemas/references';

export function getRestrictedProductFormCodelistByWorkType(
  {work: {type}}: ManifestationImportProps,
  codelist: CodeList,
): CodeList {
  return isNullish(type)
    ? codelist
    : type === CodeListRef.WORK_TYPE.Vare
      ? {
          ...codelist,
          codes: codelist.codes.map(item =>
            isMerchProductForm(item.code) ? item : {...item, disabled: true},
          ),
        }
      : {
          ...codelist,
          codes: codelist.codes.map(item =>
            !isMerchProductForm(item.code) ? item : {...item, disabled: true},
          ),
        };
}
